import React, { FC } from 'react';
import { Box, Container, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Image from 'blog/components/Image';

interface imageSectionProps {
  image: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(15),
    marginBottom: theme.spacing(12),
  },
  imageWrapper: {
    width: '100%',
    maxWidth: 1285,
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
}));

const NewsImageSection: FC<imageSectionProps> = ({ image }) => {
  const classes = useStyles({ image });

  return (
    <Container fixed className={classes.root}>
      <Box display="flex" justifyContent="center">
        <Box className={classes.imageWrapper}>
          <Image src={image} alt={image} width={1285} height={550} className={classes.image} />
        </Box>
      </Box>
    </Container>
  );
};

export default NewsImageSection;
